import { render, staticRenderFns } from "./RobotHot.vue?vue&type=template&id=4991d46a"
import script from "./RobotHot.vue?vue&type=script&lang=js"
export * from "./RobotHot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports